<template>
  <div id="ywhc-permission">
    <div class="main">
      <div class="title">
        <img src="../../assets/images/LTicon.png" alt="" />
        <span>源网荷储权限配置</span>
      </div>

      <div class="query-form">
        <el-form class="form" :inline="true">
          <el-form-item label="角色/用户">
            <el-input v-model.trim="keyword" placeholder="请输入角色或用户名称" clearable />
          </el-form-item>
          <el-form-item label="当前模拟用户">
            <el-select v-model="currentUserId" @change="persistState">
              <el-option
                v-for="user in users"
                :key="user.id"
                :label="user.name + ' / ' + roleName(user.roleId)"
                :value="user.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <div class="query-button">
          <el-button type="primary" icon="el-icon-search">查询</el-button>
          <el-button type="primary" icon="el-icon-refresh" @click="resetState">重置演示数据</el-button>
        </div>
      </div>

      <div class="permission-summary">
        <div>
          <span>当前角色</span>
          <strong>{{ currentRole.name }}</strong>
        </div>
        <div>
          <span>数据范围</span>
          <strong>{{ currentRole.scopeType }}</strong>
        </div>
        <div>
          <span>可访问模块</span>
          <strong>{{ currentRole.menuIds.length }}</strong>
        </div>
        <div>
          <span>按钮权限</span>
          <strong>{{ currentRole.buttonCodes.length }}</strong>
        </div>
      </div>

      <el-tabs v-model="activeTab" class="permission-tabs">
        <el-tab-pane label="角色权限" name="role">
          <div class="toolbar">
            <el-button type="primary" icon="el-icon-plus" :disabled="!can('role:create')" @click="openRoleDialog()">
              新建角色
            </el-button>
            <el-button icon="el-icon-lock" :disabled="!can('role:assign')" @click="openMenuDialog(activeRole)">
              菜单授权
            </el-button>
            <el-button icon="el-icon-s-operation" :disabled="!can('role:assign')" @click="openScopeDialog(activeRole)">
              数据范围
            </el-button>
          </div>
          <el-table class="table" :data="filteredRoles" highlight-current-row @current-change="selectRole">
            <el-table-column align="center" type="index" label="序号" width="70" />
            <el-table-column align="center" prop="name" label="角色名称" min-width="150" />
            <el-table-column align="center" prop="code" label="角色编码" min-width="140" />
            <el-table-column align="center" prop="scopeType" label="数据范围" min-width="120" />
            <el-table-column align="center" label="菜单数" width="90">
              <template slot-scope="{ row }">{{ row.menuIds.length }}</template>
            </el-table-column>
            <el-table-column align="center" label="按钮数" width="90">
              <template slot-scope="{ row }">{{ row.buttonCodes.length }}</template>
            </el-table-column>
            <el-table-column align="center" prop="status" label="状态" width="90">
              <template slot-scope="{ row }">
                <el-tag size="mini" :type="row.status === '启用' ? 'success' : 'info'">{{ row.status }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="300" fixed="right">
              <template slot-scope="{ row }">
                <el-button type="text" @click="openRoleDialog(row)">编辑</el-button>
                <span>|</span>
                <el-button type="text" :disabled="!can('role:assign')" @click="openMenuDialog(row)">菜单</el-button>
                <span>|</span>
                <el-button type="text" :disabled="!can('role:assign')" @click="openScopeDialog(row)">范围</el-button>
                <span>|</span>
                <el-button type="text" :disabled="!can('role:edit')" @click="toggleRole(row)">
                  {{ row.status === "启用" ? "停用" : "启用" }}
                </el-button>
                <span>|</span>
                <el-button type="text" :disabled="!can('role:delete')" @click="deleteRole(row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="用户授权" name="user">
          <div class="toolbar">
            <el-button type="primary" icon="el-icon-plus" :disabled="!can('user:create')" @click="openUserDialog()">
              新建用户
            </el-button>
          </div>
          <el-table class="table" :data="filteredUsers">
            <el-table-column align="center" type="index" label="序号" width="70" />
            <el-table-column align="center" prop="name" label="用户名称" min-width="130" />
            <el-table-column align="center" prop="account" label="账号" min-width="130" />
            <el-table-column align="center" label="角色" min-width="150">
              <template slot-scope="{ row }">{{ roleName(row.roleId) }}</template>
            </el-table-column>
            <el-table-column align="center" prop="station" label="所属场站" min-width="150" />
            <el-table-column align="center" prop="phone" label="联系方式" min-width="130" />
            <el-table-column align="center" prop="status" label="状态" width="90">
              <template slot-scope="{ row }">
                <el-tag size="mini" :type="row.status === '启用' ? 'success' : 'info'">{{ row.status }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="220" fixed="right">
              <template slot-scope="{ row }">
                <el-button type="text" @click="openUserDialog(row)">编辑</el-button>
                <span>|</span>
                <el-button type="text" :disabled="!can('user:edit')" @click="toggleUser(row)">
                  {{ row.status === "启用" ? "停用" : "启用" }}
                </el-button>
                <span>|</span>
                <el-button type="text" :disabled="!can('user:delete')" @click="deleteUser(row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="菜单与按钮" name="menu">
          <div class="menu-layout">
            <div class="tree-card">
              <div class="card-title">目标菜单树</div>
              <el-tree
                :data="menuTree"
                node-key="id"
                default-expand-all
                :props="{ children: 'children', label: 'name' }"
              />
            </div>
            <div class="tree-card">
              <div class="card-title">当前角色按钮权限</div>
              <el-checkbox-group v-model="buttonPreview" disabled>
                <el-checkbox v-for="button in buttonOptions" :key="button.code" :label="button.code">
                  {{ button.name }}
                </el-checkbox>
              </el-checkbox-group>
              <div class="hint">请在“角色权限”中点击“菜单”调整授权。</div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="数据范围" name="scope">
          <el-table class="table" :data="roles">
            <el-table-column align="center" prop="name" label="角色" min-width="150" />
            <el-table-column align="center" prop="scopeType" label="范围类型" min-width="120" />
            <el-table-column align="center" label="可见场站" min-width="360">
              <template slot-scope="{ row }">{{ row.stationScope.join("、") }}</template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="120">
              <template slot-scope="{ row }">
                <el-button type="text" :disabled="!can('role:assign')" @click="openScopeDialog(row)">配置</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="操作记录" name="log">
          <el-table class="table" :data="logs">
            <el-table-column align="center" prop="time" label="时间" width="180" />
            <el-table-column align="center" prop="operator" label="操作人" width="130" />
            <el-table-column align="center" prop="action" label="操作" min-width="180" />
            <el-table-column align="center" prop="target" label="对象" min-width="160" />
            <el-table-column align="center" prop="result" label="结果" width="100" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog :title="roleForm.id ? '编辑角色' : '新建角色'" :visible.sync="roleDialog" width="620px">
      <el-form class="dialog-form" :model="roleForm" label-width="100px">
        <el-form-item label="角色名称">
          <el-input v-model.trim="roleForm.name" placeholder="请输入角色名称" />
        </el-form-item>
        <el-form-item label="角色编码">
          <el-input v-model.trim="roleForm.code" placeholder="请输入角色编码" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="roleForm.status">
            <el-radio label="启用">启用</el-radio>
            <el-radio label="停用">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model.trim="roleForm.remark" type="textarea" placeholder="请输入角色说明" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="roleDialog = false">取消</el-button>
        <el-button type="primary" @click="saveRole">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="菜单与按钮授权" :visible.sync="menuDialog" width="760px">
      <div class="auth-dialog">
        <div>
          <div class="card-title">菜单权限</div>
          <el-tree
            ref="menuTree"
            :data="menuTree"
            node-key="id"
            show-checkbox
            default-expand-all
            :props="{ children: 'children', label: 'name' }"
          />
        </div>
        <div>
          <div class="card-title">按钮权限</div>
          <el-checkbox-group v-model="checkedButtons">
            <el-checkbox v-for="button in buttonOptions" :key="button.code" :label="button.code">
              {{ button.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="menuDialog = false">取消</el-button>
        <el-button type="primary" @click="saveMenuAuth">保存授权</el-button>
      </div>
    </el-dialog>

    <el-dialog title="数据范围配置" :visible.sync="scopeDialog" width="620px">
      <el-form class="dialog-form" label-width="100px">
        <el-form-item label="范围类型">
          <el-radio-group v-model="scopeForm.scopeType">
            <el-radio label="全部场站">全部场站</el-radio>
            <el-radio label="指定场站">指定场站</el-radio>
            <el-radio label="本人场站">本人场站</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="可见场站">
          <el-checkbox-group v-model="scopeForm.stationScope" :disabled="scopeForm.scopeType === '全部场站'">
            <el-checkbox v-for="station in stationOptions" :key="station" :label="station">{{ station }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="scopeDialog = false">取消</el-button>
        <el-button type="primary" @click="saveScope">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="userForm.id ? '编辑用户' : '新建用户'" :visible.sync="userDialog" width="620px">
      <el-form class="dialog-form" :model="userForm" label-width="100px">
        <el-form-item label="用户名称">
          <el-input v-model.trim="userForm.name" placeholder="请输入用户名称" />
        </el-form-item>
        <el-form-item label="账号">
          <el-input v-model.trim="userForm.account" placeholder="请输入登录账号" />
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="userForm.roleId" placeholder="请选择角色">
            <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="所属场站">
          <el-select v-model="userForm.station" placeholder="请选择场站">
            <el-option v-for="station in stationOptions" :key="station" :label="station" :value="station" />
          </el-select>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model.trim="userForm.phone" placeholder="请输入联系方式" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="userForm.status">
            <el-radio label="启用">启用</el-radio>
            <el-radio label="停用">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="userDialog = false">取消</el-button>
        <el-button type="primary" @click="saveUser">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const STORAGE_KEY = "ywhc-permission-state-v1";

function clone(data) {
  return JSON.parse(JSON.stringify(data));
}

function defaultState() {
  const stations = ["北区公交场站", "南区充电场站", "综合能源站", "储能示范站"];
  const menuTree = [
    {
      id: "cockpit",
      name: "源网荷储驾驶舱",
      children: [
        { id: "source", name: "源侧发电" },
        { id: "grid", name: "网侧配电" },
        { id: "load", name: "荷侧负荷" },
        { id: "storage", name: "储侧储能" },
      ],
    },
    {
      id: "operation",
      name: "运维管理",
      children: [
        { id: "alarm", name: "告警管理" },
        { id: "inspection", name: "巡检任务" },
        { id: "repair", name: "抢修任务" },
      ],
    },
    {
      id: "system",
      name: "系统设置",
      children: [
        { id: "device", name: "设备管理" },
        { id: "station", name: "场站管理" },
        { id: "permission", name: "权限配置" },
      ],
    },
  ];
  const allMenus = ["cockpit", "source", "grid", "load", "storage", "operation", "alarm", "inspection", "repair", "system", "device", "station", "permission"];
  const allButtons = ["role:create", "role:edit", "role:delete", "role:assign", "user:create", "user:edit", "user:delete", "device:edit", "alarm:handle", "storage:control"];
  return {
    currentUserId: "u1",
    stationOptions: stations,
    menuTree,
    roles: [
      {
        id: "r1",
        name: "系统管理员",
        code: "YWHC_ADMIN",
        status: "启用",
        scopeType: "全部场站",
        stationScope: stations,
        menuIds: allMenus,
        buttonCodes: allButtons,
        remark: "可维护源网荷储系统全部菜单、按钮和数据范围。",
      },
      {
        id: "r2",
        name: "运维值班员",
        code: "YWHC_OPERATOR",
        status: "启用",
        scopeType: "指定场站",
        stationScope: ["北区公交场站", "综合能源站"],
        menuIds: ["cockpit", "source", "grid", "load", "storage", "operation", "alarm", "inspection", "repair"],
        buttonCodes: ["alarm:handle", "device:edit"],
        remark: "面向日常巡检、告警处理和设备状态维护。",
      },
      {
        id: "r3",
        name: "甲方查看用户",
        code: "YWHC_VIEWER",
        status: "启用",
        scopeType: "本人场站",
        stationScope: ["综合能源站"],
        menuIds: ["cockpit", "source", "grid", "load", "storage"],
        buttonCodes: [],
        remark: "只查看驾驶舱和统计数据，不允许修改。",
      },
    ],
    users: [
      { id: "u1", name: "管理员", account: "admin", roleId: "r1", station: "综合能源站", phone: "13800000000", status: "启用" },
      { id: "u2", name: "运维人员", account: "operator", roleId: "r2", station: "北区公交场站", phone: "13800000001", status: "启用" },
      { id: "u3", name: "甲方查看", account: "viewer", roleId: "r3", station: "综合能源站", phone: "13800000002", status: "启用" },
    ],
    logs: [
      { time: "2026-06-09 09:00:00", operator: "系统", action: "初始化演示权限", target: "源网荷储权限配置", result: "成功" },
    ],
  };
}

export default {
  name: "YwhcPermission",
  data() {
    return {
      activeTab: "role",
      keyword: "",
      activeRoleId: "r1",
      currentUserId: "u1",
      stationOptions: [],
      menuTree: [],
      roles: [],
      users: [],
      logs: [],
      roleDialog: false,
      menuDialog: false,
      scopeDialog: false,
      userDialog: false,
      editingRoleId: "",
      checkedButtons: [],
      roleForm: this.blankRole(),
      scopeForm: {
        id: "",
        scopeType: "指定场站",
        stationScope: [],
      },
      userForm: this.blankUser(),
      buttonOptions: [
        { code: "role:create", name: "新建角色" },
        { code: "role:edit", name: "编辑角色" },
        { code: "role:delete", name: "删除角色" },
        { code: "role:assign", name: "授权配置" },
        { code: "user:create", name: "新建用户" },
        { code: "user:edit", name: "编辑用户" },
        { code: "user:delete", name: "删除用户" },
        { code: "device:edit", name: "设备维护" },
        { code: "alarm:handle", name: "告警处理" },
        { code: "storage:control", name: "储能控制" },
      ],
    };
  },
  computed: {
    currentUser() {
      return this.users.find((item) => item.id === this.currentUserId) || this.users[0] || {};
    },
    currentRole() {
      return this.roles.find((item) => item.id === this.currentUser.roleId) || this.roles[0] || { menuIds: [], buttonCodes: [], stationScope: [] };
    },
    activeRole() {
      return this.roles.find((item) => item.id === this.activeRoleId) || this.roles[0] || { menuIds: [], buttonCodes: [], stationScope: [] };
    },
    filteredRoles() {
      if (!this.keyword) return this.roles;
      return this.roles.filter((item) => item.name.includes(this.keyword) || item.code.includes(this.keyword));
    },
    filteredUsers() {
      if (!this.keyword) return this.users;
      return this.users.filter((item) => item.name.includes(this.keyword) || item.account.includes(this.keyword) || this.roleName(item.roleId).includes(this.keyword));
    },
    buttonPreview() {
      return this.activeRole.buttonCodes || [];
    },
  },
  created() {
    this.$store.commit("increment", "系统设置");
    this.$store.commit("selectChild", "源网荷储权限配置");
    this.$store.commit("selectChildren", "");
    this.loadState();
  },
  methods: {
    blankRole() {
      return {
        id: "",
        name: "",
        code: "",
        status: "启用",
        scopeType: "指定场站",
        stationScope: [],
        menuIds: [],
        buttonCodes: [],
        remark: "",
      };
    },
    blankUser() {
      return {
        id: "",
        name: "",
        account: "",
        roleId: "",
        station: "",
        phone: "",
        status: "启用",
      };
    },
    loadState() {
      const base = defaultState();
      let state = base;
      try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) state = Object.assign(base, JSON.parse(saved));
      } catch (error) {
        state = base;
      }
      this.currentUserId = state.currentUserId;
      this.stationOptions = state.stationOptions;
      this.menuTree = state.menuTree;
      this.roles = state.roles;
      this.users = state.users;
      this.logs = state.logs;
      this.activeRoleId = this.roles[0] ? this.roles[0].id : "";
    },
    persistState() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        currentUserId: this.currentUserId,
        stationOptions: this.stationOptions,
        menuTree: this.menuTree,
        roles: this.roles,
        users: this.users,
        logs: this.logs,
      }));
    },
    resetState() {
      localStorage.removeItem(STORAGE_KEY);
      this.loadState();
      this.addLog("重置演示数据", "权限配置");
      this.$message.success("已重置为默认源网荷储权限数据");
    },
    can(code) {
      return (this.currentRole.buttonCodes || []).includes(code);
    },
    roleName(roleId) {
      const role = this.roles.find((item) => item.id === roleId);
      return role ? role.name : "-";
    },
    selectRole(row) {
      if (row) this.activeRoleId = row.id;
    },
    openRoleDialog(row) {
      if (row && !this.can("role:edit")) {
        this.$message.warning("当前角色无编辑角色权限");
        return;
      }
      this.roleForm = row ? clone(row) : Object.assign(this.blankRole(), {
        id: "",
        scopeType: "指定场站",
        stationScope: [this.stationOptions[0]],
        menuIds: ["cockpit", "source", "grid", "load", "storage"],
      });
      this.roleDialog = true;
    },
    saveRole() {
      if (!this.roleForm.name || !this.roleForm.code) {
        this.$message.warning("请填写角色名称和角色编码");
        return;
      }
      if (this.roleForm.id) {
        const index = this.roles.findIndex((item) => item.id === this.roleForm.id);
        if (index > -1) this.roles.splice(index, 1, clone(this.roleForm));
        this.addLog("编辑角色", this.roleForm.name);
      } else {
        const role = Object.assign(clone(this.roleForm), {
          id: `r${Date.now()}`,
          buttonCodes: [],
        });
        this.roles.unshift(role);
        this.activeRoleId = role.id;
        this.addLog("新建角色", role.name);
      }
      this.roleDialog = false;
      this.persistState();
      this.$message.success("角色已保存");
    },
    toggleRole(row) {
      row.status = row.status === "启用" ? "停用" : "启用";
      this.addLog(`${row.status === "启用" ? "启用" : "停用"}角色`, row.name);
      this.persistState();
    },
    deleteRole(row) {
      if (this.users.some((item) => item.roleId === row.id)) {
        this.$message.warning("该角色已绑定用户，请先调整用户角色");
        return;
      }
      this.roles = this.roles.filter((item) => item.id !== row.id);
      this.activeRoleId = this.roles[0] ? this.roles[0].id : "";
      this.addLog("删除角色", row.name);
      this.persistState();
    },
    openMenuDialog(row) {
      const role = row || this.activeRole;
      if (!role.id) return;
      this.editingRoleId = role.id;
      this.checkedButtons = clone(role.buttonCodes || []);
      this.menuDialog = true;
      this.$nextTick(() => {
        if (this.$refs.menuTree) this.$refs.menuTree.setCheckedKeys(role.menuIds || []);
      });
    },
    saveMenuAuth() {
      const role = this.roles.find((item) => item.id === this.editingRoleId);
      if (!role) return;
      role.menuIds = this.$refs.menuTree.getCheckedKeys();
      role.buttonCodes = clone(this.checkedButtons);
      this.menuDialog = false;
      this.addLog("调整菜单按钮权限", role.name);
      this.persistState();
      this.$message.success("授权已保存");
    },
    openScopeDialog(row) {
      const role = row || this.activeRole;
      if (!role.id) return;
      this.scopeForm = {
        id: role.id,
        scopeType: role.scopeType,
        stationScope: clone(role.stationScope || []),
      };
      this.scopeDialog = true;
    },
    saveScope() {
      const role = this.roles.find((item) => item.id === this.scopeForm.id);
      if (!role) return;
      role.scopeType = this.scopeForm.scopeType;
      role.stationScope = this.scopeForm.scopeType === "全部场站" ? clone(this.stationOptions) : clone(this.scopeForm.stationScope);
      this.scopeDialog = false;
      this.addLog("调整数据范围", role.name);
      this.persistState();
      this.$message.success("数据范围已保存");
    },
    openUserDialog(row) {
      if (row && !this.can("user:edit")) {
        this.$message.warning("当前角色无编辑用户权限");
        return;
      }
      this.userForm = row ? clone(row) : Object.assign(this.blankUser(), {
        roleId: this.roles[0] ? this.roles[0].id : "",
        station: this.stationOptions[0],
      });
      this.userDialog = true;
    },
    saveUser() {
      if (!this.userForm.name || !this.userForm.account || !this.userForm.roleId) {
        this.$message.warning("请填写用户名称、账号和角色");
        return;
      }
      if (this.userForm.id) {
        const index = this.users.findIndex((item) => item.id === this.userForm.id);
        if (index > -1) this.users.splice(index, 1, clone(this.userForm));
        this.addLog("编辑用户", this.userForm.name);
      } else {
        const user = Object.assign(clone(this.userForm), { id: `u${Date.now()}` });
        this.users.unshift(user);
        this.addLog("新建用户", user.name);
      }
      this.userDialog = false;
      this.persistState();
      this.$message.success("用户已保存");
    },
    toggleUser(row) {
      row.status = row.status === "启用" ? "停用" : "启用";
      this.addLog(`${row.status === "启用" ? "启用" : "停用"}用户`, row.name);
      this.persistState();
    },
    deleteUser(row) {
      if (row.id === this.currentUserId) {
        this.$message.warning("不能删除当前模拟用户");
        return;
      }
      this.users = this.users.filter((item) => item.id !== row.id);
      this.addLog("删除用户", row.name);
      this.persistState();
    },
    addLog(action, target) {
      const date = new Date();
      const pad = (num) => String(num).padStart(2, "0");
      const time = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
      this.logs.unshift({
        time,
        operator: this.currentUser.name || "当前用户",
        action,
        target,
        result: "成功",
      });
      this.logs = this.logs.slice(0, 50);
      this.persistState();
    },
  },
};
</script>

<style scoped>
#ywhc-permission {
  width: 100%;
  height: 100%;
  color: #aed6ff;
  overflow: auto;
}
.main {
  width: 100%;
  min-height: calc(100vh - 121px);
  padding: 20px;
  box-sizing: border-box;
}
.title {
  height: 34px;
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}
.title img {
  width: 20px;
  margin-right: 10px;
}
.title span {
  color: #e8f4ff;
  font-size: 16px;
  font-weight: 700;
}
.query-form {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 18px;
  border: 1px solid rgba(80, 137, 235, 0.24);
  background: rgba(9, 34, 89, 0.62);
}
.form {
  display: flex;
  align-items: center;
}
.query-button {
  display: flex;
  gap: 10px;
}
.permission-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin: 16px 0;
}
.permission-summary div {
  height: 86px;
  padding: 16px 18px;
  box-sizing: border-box;
  background: rgba(41, 88, 164, 0.34);
  border: 1px solid rgba(80, 137, 235, 0.26);
}
.permission-summary span {
  display: block;
  color: #9ec6ef;
  font-size: 13px;
}
.permission-summary strong {
  display: block;
  margin-top: 10px;
  color: #40ecc2;
  font-size: 24px;
}
.permission-tabs {
  padding: 18px;
  background: rgba(4, 28, 76, 0.5);
  border: 1px solid rgba(80, 137, 235, 0.22);
}
.toolbar {
  margin-bottom: 14px;
}
.table {
  width: 100%;
}
.menu-layout,
.auth-dialog {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}
.tree-card {
  min-height: 360px;
  padding: 16px;
  border: 1px solid rgba(80, 137, 235, 0.24);
  background: rgba(9, 34, 89, 0.42);
}
.card-title {
  margin-bottom: 14px;
  color: #e8f4ff;
  font-size: 15px;
  font-weight: 700;
}
.hint {
  margin-top: 18px;
  color: #f6cd29;
  font-size: 12px;
}
.dialog-form {
  padding: 0 20px;
}
.dialog-footer {
  text-align: right;
}
</style>

<style>
#ywhc-permission .el-form-item__label,
#ywhc-permission .el-tabs__item,
#ywhc-permission .el-checkbox,
#ywhc-permission .el-radio {
  color: #aed6ff;
}
#ywhc-permission .el-tabs__item.is-active {
  color: #409eff;
}
#ywhc-permission .el-table,
#ywhc-permission .el-table tr,
#ywhc-permission .el-table th,
#ywhc-permission .el-table td {
  background: transparent !important;
}
#ywhc-permission .el-table th {
  color: #e8f4ff;
  font-size: 14px;
}
#ywhc-permission .el-table td {
  color: #aed6ff;
  border-bottom-color: rgba(80, 137, 235, 0.22);
}
#ywhc-permission .el-table::before {
  display: none;
}
#ywhc-permission .el-input__inner,
#ywhc-permission .el-textarea__inner {
  color: #aed6ff;
  background: #041c4c;
  border-color: #193f92;
}
#ywhc-permission .el-tree {
  color: #aed6ff;
  background: transparent;
}
#ywhc-permission .el-tree-node__content:hover,
#ywhc-permission .el-tree-node:focus > .el-tree-node__content {
  background: rgba(25, 63, 146, 0.65);
}
#ywhc-permission .el-dialog {
  background: #041c4c;
}
#ywhc-permission .el-dialog__title {
  color: #e8f4ff;
}
</style>
